import actionNames from './actionNames'

const mutations = {
  // UI State mutations
  [actionNames.SHOW_SETTINGS_VIEW](state, view) {
    state.selectedTab = view || 'profile'
  },

  [actionNames.UNKNOWN_ERROR](state, error) {
    state.hasError = true
    state.errorMessage = error?.message || 'An unknown error occurred'
    state.isLoading = false
  },

  // User Settings mutations
  [actionNames.GET_USER_SETTINGS_REQUESTED](state) {
    state.isLoading = true
    state.hasError = false
    state.errorMessage = null
  },

  [actionNames.GET_USER_SETTINGS_SUCCEEDED](state, settings) {
    state.isLoading = false
    state.hasError = false
    state.userSettings = { ...state.userSettings, ...settings }
    state.lastUpdated = new Date().toISOString()
  },

  [actionNames.GET_USER_SETTINGS_FAILED](state, error) {
    state.isLoading = false
    state.hasError = true
    state.errorMessage = error?.message || 'Failed to fetch user settings'
  },

  [actionNames.UPDATE_USER_SETTINGS_REQUESTED](state) {
    state.isLoading = true
    state.hasError = false
    state.errorMessage = null
  },

  [actionNames.UPDATE_USER_SETTINGS_SUCCEEDED](state, settings) {
    state.isLoading = false
    state.hasError = false
    state.userSettings = { ...state.userSettings, ...settings }
    state.lastUpdated = new Date().toISOString()
  },

  [actionNames.UPDATE_USER_SETTINGS_FAILED](state, error) {
    state.isLoading = false
    state.hasError = true
    state.errorMessage = error?.message || 'Failed to update user settings'
  },

  // Profile mutations
  [actionNames.UPDATE_PROFILE_SUCCEEDED](state, profile) {
    state.userSettings.profile = { ...state.userSettings.profile, ...profile }
    state.lastUpdated = new Date().toISOString()
  },

  // Preferences mutations
  [actionNames.UPDATE_PREFERENCES_SUCCEEDED](state, preferences) {
    state.userSettings.preferences = { ...state.userSettings.preferences, ...preferences }
    state.lastUpdated = new Date().toISOString()
  },

  // Notifications mutations
  [actionNames.UPDATE_NOTIFICATIONS_SUCCEEDED](state, notifications) {
    state.userSettings.notifications = { ...state.userSettings.notifications, ...notifications }
    state.lastUpdated = new Date().toISOString()
  },

  // Security mutations
  [actionNames.UPDATE_SECURITY_SUCCEEDED](state, security) {
    state.userSettings.security = { ...state.userSettings.security, ...security }
    state.lastUpdated = new Date().toISOString()
  },

  // Demo mode mutations
  updateDemoMode(state, demoSettings) {
    state.demoMode = { ...state.demoMode, ...demoSettings }
  },

  // Alias mutations
  updateAliasSettings(state, aliasSettings) {
    state.aliasSettings = { ...state.aliasSettings, ...aliasSettings }
  },

  // Theme mutations
  updateTheme(state, theme) {
    state.userSettings.preferences.theme = theme
    state.lastUpdated = new Date().toISOString()
  },

  // Saved filters mutations
  updateSavedFilters(state, filters) {
    state.savedFilters = filters
  },

  // Custom reports mutations
  updateCustomReports(state, reports) {
    state.customReports = reports
  },

  // Error handling
  clearError(state) {
    state.hasError = false
    state.errorMessage = null
  },

  // Reset state
  resetSettings(state) {
    const defaultState = {
      preferences: {
        theme: 'light',
        language: 'en',
        timezone: 'UTC',
        dateFormat: 'MM/dd/yyyy',
        timeFormat: '12h',
      },
      notifications: {
        email: {
          enabled: true,
          digest: 'daily',
          marketing: false,
        },
        push: {
          enabled: true,
          browser: true,
          mobile: false,
        },
        alerts: {
          systemMaintenance: true,
          securityUpdates: true,
          featureUpdates: false,
        },
      },
      security: {
        twoFactorAuth: false,
        sessionTimeout: 30,
        passwordExpiry: 90,
      },
      privacy: {
        shareUsageData: false,
        allowAnalytics: true,
        shareProfileData: false,
      },
    }

    Object.keys(defaultState).forEach((key) => {
      if (state.userSettings[key]) {
        state.userSettings[key] = defaultState[key]
      }
    })

    state.lastUpdated = new Date().toISOString()
  },
}

export default mutations
